import { type StoredAuth } from "./auth-client-types";

export const DEFAULT_AUTH_STORAGE_KEY = "auth";
export const DEFAULT_ME_STORAGE_KEY = "securityMe";
export const DEFAULT_REDIRECT_URL_KEY = "authRedirectUrl";

export function readStoredAuth(key = DEFAULT_AUTH_STORAGE_KEY) {
  if (typeof window === "undefined") {
    return null;
  }

  const rawAuth = localStorage.getItem(key);

  if (!rawAuth) {
    return null;
  }

  try {
    const parsedAuth: unknown = JSON.parse(rawAuth);

    if (!isStoredAuth(parsedAuth)) {
      return null;
    }

    return parsedAuth;
  } catch {
    return null;
  }
}

export function writeStoredAuth(key: string, auth: StoredAuth) {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.setItem(key, JSON.stringify(auth));
}

export function toInternalRedirectPath(url: URL | string) {
  const parsedUrl =
    typeof url === "string" ? new URL(url, window.location.origin) : url;

  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
}

export function normalizeRedirectPath(value: string | null) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return "/";
  }

  return value;
}

function isStoredAuth(value: unknown): value is StoredAuth {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  return (
    "accessToken" in value &&
    typeof value.accessToken === "string" &&
    "idToken" in value &&
    typeof value.idToken === "string" &&
    "refreshToken" in value &&
    (typeof value.refreshToken === "string" || value.refreshToken === null) &&
    "expiresAt" in value &&
    (typeof value.expiresAt === "number" || value.expiresAt === null)
  );
}
